export default "__VITE_ASSET__kbA646gi__"